import {connect} from "react-redux";
import BAActivitySave from "./Save";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {activityTypes, getSenior} from "../../../../service/Dealer/action";
import {getPendingActivity} from "../../../../service/BA/action";
import {saveActivity, markAttendance, accountByLeadId} from "../../../../service/BA/action";
import {isCheckout} from "../../../../service/CarService/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    activityTypesDetails:state.Dealer.activityTypesDetails,
    senior:state.Dealer.senior,
    saveActivityRes:state.BA.saveActivityRes,
    pendingActivity:state.Valet.pendingActivity,
    isCheckoutDetails:state.CarService.isCheckout,
    attendance:state.BA.attendance,
    accountLeadId:state.BA.accountLeadId,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            activityTypes,
            getSenior,
            saveActivity,
            getPendingActivity,
            isCheckout,
            markAttendance,
            accountByLeadId
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(BAActivitySave);
